import Flatpickr from 'react-flatpickr';

/**
 * react-flatpickr@3.10.7 assumes its flatpickr instance always exists:
 *
 *   componentWillUnmount() { this.flatpickr.destroy(); }
 *   componentDidUpdate()   { this.flatpickr.set(...) }
 *
 * When the underlying input never gets an instance (the ref hasn't attached yet,
 * or the tree unmounts in the same commit that mounted it — e.g. a modal closing
 * right after opening), `this.flatpickr` is null and those calls throw
 * "Cannot read properties of null (reading 'destroy')", which bubbles up to the
 * error boundary and blanks the page. A reload works because the race doesn't
 * repeat.
 *
 * Guarding the two lifecycle methods on the prototype fixes every <Flatpickr />
 * in the app at once. Remove this once the library ships the null checks.
 */
const patchFlatpickrLifecycle = () => {
  const proto = Flatpickr?.prototype;
  if (!proto || proto.__thriweNullGuardApplied) return;

  const { componentWillUnmount, componentDidUpdate } = proto;

  proto.componentWillUnmount = function safeComponentWillUnmount(...args) {
    if (!this.flatpickr) return; // nothing was ever created — nothing to destroy
    componentWillUnmount?.apply(this, args);
  };

  proto.componentDidUpdate = function safeComponentDidUpdate(...args) {
    if (!this.flatpickr) return;
    componentDidUpdate?.apply(this, args);
  };

  proto.__thriweNullGuardApplied = true;
};

export default patchFlatpickrLifecycle;
